<template>
<div class="pagewide payments mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('plans.paymentsCaptions')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <payments />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>

import payments from "@/components/modules/panel/payments/index.vue"


export default {
	name: 'panel_payments_page',
	components: {
		payments
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
